import React from 'react';
import styled from 'styled-components';
import { ActionButton, StackPanel, Typography } from '@agilepoint/wat-react-ux';
import { TextBoxField } from '@agilepoint/wat-react-ux-form-fields';
import { FormProvider, useForm } from 'react-hook-form';
import { StyledPrimaryButton } from 'common';

interface IResetPasswordcontrolsProps {

}


const StyledForm = styled.form`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 350px;
    height: 100%;
`;

const LoginControlsBaseWrapper = styled(StackPanel)`
    margin-left 80px;
    justify-content: center;
    align-items: center;
    display: grid;
    width: 320px;
    row-gap:5px;
`;

const Heading = styled(Typography.H2)`
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 10px;
    text-align: left;
    padding-bottom: 20px;
`;

const ResetMessage = styled(Typography.H6)`
    font-family: RobotoRegular, sans-serif;
    line-height: 20px;
    font-size:14px;
    font-weight:400;
`;

const StyledFormInputs = styled(StackPanel)`
    padding-top: 20px;
`;

const StyledTextBoxField = styled(TextBoxField)`
    .ap-textbox-wrapper {
        width: 300px;
        height: 40px;
        padding:0px;
        .ap-textbox{
            padding:0px 16px !important;
        }
    }
    .ap-formField-label {
        margin-bottom:10px;
    }
    .ap-formField-label span {
        font-size: 16px;
        font-weight:500;
        line-height: 19px;
        color:${({ theme: { semantics: { palette } } }) => palette.neutralPrimary};
    }
    }
`;

const ActionButtonsWrapper = styled(StackPanel)`
    margin-top: 28px;
`;

const StyledGoBackButton = styled(ActionButton)`
    color: ${({ theme: { mobileAppAccelerator: { semanticColors } } }) => semanticColors.grayVariant3};
    
    .ap-button-label {
        font-weight: 500;
        padding-left:50px;
    }
`;

const ResetButton = styled(StyledPrimaryButton)`
    margin-right:11px;
    height: 40px;
    cursor: pointer;
    background-color: #0077d9;
    border: 0 #0077d9;
    border-radius: 22px
    color: #ffff;
    font-size: 16px;
    font-weight: 500;
    line-height: 19px;
`;

const ResetControlsBase = React.memo(() => (

    <LoginControlsBaseWrapper orientation="vertical" justifyContent="center">
        <Heading>
            Forgot Password ?
        </Heading>
        <ResetMessage>Please enter your account username below and click reset to receive a link to reset your account password in your registered email address.</ResetMessage>
        <StyledFormInputs orientation="vertical">
            <StyledTextBoxField name="username" type="text" label="User Name" placeholder='User Name' />
        </StyledFormInputs>
        <ActionButtonsWrapper width="100%" orientation="horizontal" justifyContent="space-between">
            <StyledGoBackButton label='Back' iconSize='24' />
            <ResetButton label="Reset Password" title='Reset Password' />
        </ActionButtonsWrapper>
    </LoginControlsBaseWrapper>
));


export const ResetPasswordControls = (props: IResetPasswordcontrolsProps) => {
    const methods = useForm({
        mode: 'onBlur'
    });
    return (
        <FormProvider {...methods}>
            <StyledForm>
                <ResetControlsBase />
            </StyledForm>
        </FormProvider>
    );
};

